import {
    CREATE_TASK,
    GET_TASKS,
    GET_TASK_BY_ID,
    UPDATE_TASK,
    DELETE_TASK,
    BULK_UPDATE_TASK_STATUS,
    BULK_ASSIGN_TASK,
    BULK_DELETE_TASKS,
    CREATE_TASK_COMMENT,
    GET_TASK_COMMENTS,
    DELETE_TASK_COMMENT,
} from './tasks.type';

export const createTask = (body) => {
    return {
        type: CREATE_TASK,
        payload: { body },
    };
};

export const getTasks = (params, load) => {
    return {
        type: GET_TASKS,
        payload: { params, load },
    };
};

export const getTaskById = (id) => {
    return {
        type: GET_TASK_BY_ID,
        payload: { id },
    };
};

export const updateTask = (id, body, requestParams) => {
    return {
        type: UPDATE_TASK,
        payload: { id, body, requestParams },
    };
};

export const deleteTask = (id) => {
    return {
        type: DELETE_TASK,
        payload: { id },
    };
};

export const bulkUpdateTaskStatus = (body, requestParams) => {
    return {
        type: BULK_UPDATE_TASK_STATUS,
        payload: { body, requestParams },
    };
};

export const bulkAssignTask = (body, requestParams) => {
    return {
        type: BULK_ASSIGN_TASK,
        payload: { body, requestParams },
    };
};

export const bulkDeleteTasks = (body, requestParams) => {
    return {
        type: BULK_DELETE_TASKS,
        payload: { body, requestParams },
    };
};

export const createTaskComment = (taskId, body) => {
    return {
        type: CREATE_TASK_COMMENT,
        payload: { taskId, body },
    };
};

export const getTaskComments = (taskId, params) => {
    return {
        type: GET_TASK_COMMENTS,
        payload: { taskId, params },
    };
};

export const deleteTaskComment = (taskId, commentId) => {
    return {
        type: DELETE_TASK_COMMENT,
        payload: { taskId, commentId },
    };
};
